import { render, staticRenderFns } from "./h-bank-page.vue?vue&type=template&id=7ed6eb21&"
import script from "./h-bank-page.vue?vue&type=script&lang=js&"
export * from "./h-bank-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports